<!-- ER-6829: TargetsTypeIcon Component -->
<template>
  <component :is="iconComponent" />
</template>

<script setup>
import { computed } from "vue";
import FixedIcon from "./icons/FixedIcon.vue";
import ProratedIcon from "./icons/ProratedIcon.vue";

const props = defineProps({
  icon: {
    type: String,
    required: true,
    validator: (value) => ["Fixed", "Prorated"].includes(value),
  },
});

const iconComponent = computed(() => {
  const map = {
    Fixed: FixedIcon,
    Prorated: ProratedIcon,
  };
  return map[props.icon] || FixedIcon;
});
</script>
